export default "__VITE_ASSET__49ea1e16__"